import { OneTrustCookiesList } from "components";

export const OneTrustCookiesListAdapter = () => <OneTrustCookiesList />;
